import React, { useMemo } from 'react'
import { css } from '@emotion/react'
import { useTranslation } from 'react-i18next'
import { CUSTOM_BLOCK, CUSTOM_BORDER } from '../template/custom-design-style'
import { displayYen } from '@/libs/text'

interface TotalAmountProps {
  subtotalAmount: number | undefined
  discountAmount: number | undefined
  totalAmount: number | undefined
}
export const TotalAmount: React.FC<TotalAmountProps> = props => {
  const { t } = useTranslation()

  const hasDiscount = useMemo((): boolean => Boolean(props.discountAmount && props.subtotalAmount), [props])

  return (
    <>
      <div css={totalAmountBlockStyle} className={CUSTOM_BLOCK}>
        {hasDiscount && (
          <>
            <div className="summary-line">
              <p>{t('Usage fee')}</p>
              <p>{displayYen(props.subtotalAmount || 0)}</p>
            </div>
            <div className="summary-line">
              <p>{t('Guest discounts')}</p>
              <p>-{displayYen(props.discountAmount || 0)}</p>
            </div>
          </>
        )}
        <div className={`total-line ${hasDiscount ? CUSTOM_BORDER : ''}`} style={hasDiscount ? { marginTop: 12, paddingTop: 12 } : {}}>
          <p>{t('Amount billed (tax included)')}</p>
          <p>{displayYen(props.totalAmount || 0)}</p>
        </div>
      </div>
    </>
  )
}

const totalAmountBlockStyle = css({
  marginTop: 8,
  padding: '24px 32px',
  '.summary-line, .total-line': {
    fontWeight: 'bold',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    fontSize: 14,
  },
  '.summary-line': { paddingTop: 12 },
  '.total-line': {
    p: { '&:first-of-type': { fontSize: '16px' } },
    fontSize: '20px',
    borderBottom: 'none',
    borderLeft: 'none',
    borderRight: 'none',
  },
})
